export default __webpack_public_path__ + "static/media/Audio_2021_HTB600_EGEBGNGAGJ_Gallery_Image_1_210202.d0e4aa72.jpg";